import React from 'react';
import { ArrowUpRight, ShoppingBag, Settings2, Wrench, RefreshCw, Sparkles, Accessibility, Component, MapPin, Building2 } from 'lucide-react';
import { WhatsAppLink } from './WhatsAppLink';

const services = [
  [ShoppingBag, 'Venda', 'Orientação para a escolha do equipamento ideal.'],
  [Settings2, 'Instalação', 'Montagem com cuidado técnico em cada etapa.'],
  [Wrench, 'Manutenção', 'Prevenção e correção para cuidar do seu elevador.'],
  [RefreshCw, 'Reformas', 'Renovação que acompanha novas necessidades.'],
  [Sparkles, 'Embelezamento de cabinas', 'Acabamentos que valorizam o seu ambiente.'],
  [Accessibility, 'Acessibilidade', 'Mobilidade e autonomia para mais pessoas.'],
  [Component, 'Comércio de peças', 'Componentes para as necessidades do seu equipamento.'],
  [Building2, 'Estrutura metálica', 'Fabricação e instalação sob medida para elevadores e plataformas.'],
];

export const Services = () => (
  <section id="services" className="section-space services-section" aria-labelledby="services-heading" data-testid="services-section">
    <div className="site-container services-layout">
      <div className="services-intro">
        <h2 className="section-kicker" id="services-heading">SERVIÇOS QUE SE COMPLETAM</h2>
        <p className="section-title" data-testid="services-title">Em cada etapa.<br />Em cada andar.</p>
        <p>Um parceiro para todo o caminho. Da escolha do elevador aos cuidados que mantêm seu equipamento em movimento.</p>
        <div className="national-note" data-testid="services-national-coverage"><MapPin size={24} /><p><strong>Atendimento nacional</strong><span>Representantes e técnicos em todo o país.</span></p></div>
        <WhatsAppLink className="fatt-button button-red" subject="os serviços da FATT" testId="services-whatsapp">Converse com nossa equipe <ArrowUpRight size={18} /></WhatsAppLink>
      </div>
      <div className="services-list">{services.map(([Icon, title, description], index) => <div className="service-item" key={title} data-testid={`service-${index}`}>
        <Icon size={24} strokeWidth={1.5} aria-hidden="true" /><div><h3>{title}</h3><p>{description}</p></div><span aria-hidden="true">0{index + 1}</span>
      </div>)}</div>
    </div>
  </section>
);